import React from "react";
import {
  Alert,
  AlertTitle,
  Slide,
  SlideProps,
  Snackbar,
  Stack,
  Link,
  IconButton,
} from "@mui/material";

import FlexBox, { FlexGrow } from "./FlexBox";
import {
  Visibility as VisibilityIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import { AnnouncementPage } from "../pages/Announcements/Announcements";

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="left" />;
}

type SnackBarProps = {
  isOpen: boolean;
  setOpen: (x: boolean) => void;
  message: string;
  header?: string;
  link?: boolean;
  type: "error" | "success" | "warning" | "info" | "announcement";
  autoHideDuration?: number;
  style?: React.CSSProperties;
};

function SnackBar({
  isOpen,
  setOpen,
  header,
  message,
  link = false,
  type,
  autoHideDuration,
  style
}: SnackBarProps): JSX.Element {
  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  const handleView = () => {
    window.location.pathname = "/announcement";
  };
  return (
    <React.Fragment>
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          style={{
            zIndex: 1000000,
            maxWidth: "600px",
            ...style,
          }}
          onClose={handleClose}
          autoHideDuration={autoHideDuration || 4000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          TransitionComponent={SlideTransition}
          open={isOpen}
          key={"topright"}
        >
          <Alert
            action={
              type === "announcement" ? (
                <>
                  <IconButton
                    size="small"
                    aria-label="view"
                    color="inherit"
                    onClick={handleView}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  {/* <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={handleClose}
                  >
                    <CloseIcon />
                  </IconButton> */}
                </>
              ) : (
                <></>
              )
            }
            onClose={handleClose}
            variant="filled"
            severity={type === "announcement" ? "info" : type}
            sx={{ width: "100%" }}
          >
            {header && header !== "" && (
              <AlertTitle
                style={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {header}
              </AlertTitle>
            )}
            <FlexBox>
              <FlexGrow>{message}</FlexGrow>
              {link && (
                <Link
                  href="/roadmap"
                  underline="hover"
                  style={{
                    marginLeft: "50px",
                    color: "white",
                    textDecoration: "underline",
                  }}
                >
                  View roadmap
                </Link>
              )}
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </FlexBox>
          </Alert>
        </Snackbar>
      </Stack>
    </React.Fragment>
  );
}

export default SnackBar;
